// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33Ngu","questions":"styles_questions__3mrTL","footer":"styles_footer__1Z2hf"};